import React, { useEffect, useState, createContext, useContext } from 'react';
import { User, UserRole } from '../types';
import { currentUser as mockUser } from '../data/mockData';
interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  login: (email: string, role: UserRole) => void;
  logout: () => void;
  isLoading: boolean;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export function AuthProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate checking local storage
    const storedUser = localStorage.getItem('lisf_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setIsLoading(false);
  }, []);
  const login = (email: string, role: UserRole) => {
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      const newUser = {
        ...mockUser,
        email,
        role
      };
      setUser(newUser);
      localStorage.setItem('lisf_user', JSON.stringify(newUser));
      setIsLoading(false);
    }, 800);
  };
  const logout = () => {
    setUser(null);
    localStorage.removeItem('lisf_user');
  };
  return <AuthContext.Provider value={{
    user,
    isAuthenticated: !!user,
    login,
    logout,
    isLoading
  }} data-id="element-133">
      {children}
    </AuthContext.Provider>;
}
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}